class Timer {
  constructor(callback) {
    this.callback = callback;
    this.startedAt = null;
    this.intervalId = null;
  }

  start() {
    this.startedAt = Date.now();
    this.intervalId = setInterval(() => {
      this.callback(Math.floor((Date.now() - this.startedAt) / 1000));
    }, 1000);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

export default Timer;
